// Reads feature flags exposed via <meta name="feature:<name>"> tags.
// Flags are enabled by default and only disabled when the meta tag is
// explicitly set to "false".
export function isFeatureDisabled(feature) {
  const meta = document.querySelector(`meta[name='feature:${feature}']`)
  return meta.content === 'false'
}
